import { featureFlagRequests } from "@/api/(requests)/featureFlagTyped";

export function handleFeatureFlagError(error, flagName, isEnabled) {
  const data = { enabled: isEnabled, flag_name: flagName };

  featureFlagRequests.post_feature_flag_error({ context: { showLoader: false }, data });
  throw error;
}
